export interface DefaultPageOption {
  value: string;
  label: string;
  icon?: string;
}

/** עמודים מחוץ לתצוגות השיחות בסרגל */
export const NON_CHAT_DEFAULT_PAGE_OPTIONS: DefaultPageOption[] = [
  {
    value: '/contacts/chat',
    label: 'אנשי קשר'
  },
  {
    value: '/calendar',
    label: 'יומן'
  },
  {
    value: '/templates/list',
    label: 'תבניות הודעות'
  },
  {
    value: '/labels',
    label: 'תגיות'
  },
  {
    value: '/drive/images',
    label: 'ספריית קבצים'
  },
  {
    value: '/boards',
    label: 'לוחות'
  },
  {
    value: '/users',
    label: 'משתמשים'
  },
  {
    value: '/broadcasts',
    label: 'תפוצה'
  },
  {
    value: '/workflows',
    label: 'בוטים'
  },
  {
    value: '/webhooks',
    label: 'וובהוקים ואינטגרציות'
  }
];

/** @deprecated השתמשו ב-useDefaultPageViewOptions — רשימה דינמית של תצוגות + עמודים נוספים */
export const DEFAULT_PAGE_OPTIONS: DefaultPageOption[] = NON_CHAT_DEFAULT_PAGE_OPTIONS;

// מפתח ב-localStorage
export const DEFAULT_HOME_PAGE_KEY = 'defaultHomePage';

// עמוד ברירת המחדל הקבוע (כמו שהיה קודם)
export const FALLBACK_DEFAULT_PAGE = '/chats';

/**
 * שומר את עמוד ברירת המחדל ב-localStorage
 */
export const saveDefaultHomePage = (path: string): void => {
  try {
    localStorage.setItem(DEFAULT_HOME_PAGE_KEY, path);
  } catch (error) {
    console.error('Error saving default home page:', error);
  }
};

/**
 * טוען את עמוד ברירת המחדל מ-localStorage
 */
export const getDefaultHomePage = (): string => {
  try {
    const savedPage = localStorage.getItem(DEFAULT_HOME_PAGE_KEY);
    return savedPage || FALLBACK_DEFAULT_PAGE;
  } catch (error) {
    console.error('Error loading default home page:', error);
    return FALLBACK_DEFAULT_PAGE;
  }
};

/**
 * מוחק את הגדרת עמוד ברירת המחדל (חזרה לברירת מחדל)
 */
export const clearDefaultHomePage = (): void => {
  try {
    localStorage.removeItem(DEFAULT_HOME_PAGE_KEY);
  } catch (error) {
    console.error('Error clearing default home page:', error);
  }
};

/**
 * בודק אם עמוד מסוים הוא עמוד תקני
 */
export const isValidDefaultPage = (path: string, knownPaths?: string[]): boolean => {
  if (knownPaths?.includes(path)) return true;
  if (NON_CHAT_DEFAULT_PAGE_OPTIONS.some((option) => option.value === path)) return true;
  if (path.startsWith('/chats')) return true;
  return false;
}; 